import React from 'react';
import './ConfirmDialog.css'; // Create your styling here

const EmptyPres = ({ open, title, onCancel }) => {
  if (!open) return null;

  return (
    <div className="confirm-dialog-overlay">
      <div className="confirm-dialog-box">
        <h3>{title}</h3>
        <p>Prescription Form is empty</p>
        <p>Please add at least one medicine or upload a Prescription</p>
        <div className="dialog-buttons">
          <button className="cancel-btn" onClick={onCancel}>Close</button>
        </div>
      </div>
    </div>
  );
};

export default EmptyPres;